<template>
  <div class="Personalnav">
    <!-- <div class="Materiaupload" v-if="this.$store.state.user.status === '已通过'">
      <div class="altk" @click="uploadmaterial()">
          <i class="iconfont gos-shangchuan1"></i>
      </div>
        <span @click="uploadmaterial()"> 素材上传</span>
    </div> -->
    <div class="concet-n">
      <div class="left">
        <el-row class="tac">
          <el-col :span="5">
            <el-menu
              :default-active="activeRoute || activeMenu"
              class="el-menu-vertical-demo"
              @open="handleOpen"
              @close="handleClose"
              router
            >
              <el-menu-item index="/Myinfor">
                <i class="iconfont gos-wodexinxi_jibenxinxi tktb"></i>
                <span slot="title">我的信息</span>
              </el-menu-item>
              <el-menu-item index="/Mycollection">
                <i
                  class="iconfont gos-cebianlan-wodeshoucang-weixuanzhong tktb"
                ></i>
                <span slot="title">我的收藏</span>
              </el-menu-item>
              <el-menu-item index="/Learningecord">
                <i class="iconfont gos-a-xuexijilulishijilushijian tktb"></i>
                <span slot="title">学习记录</span>
              </el-menu-item>
              <el-menu-item index="/Myevaluation">
                <i class="iconfont gos-daipingjia20 tktb"></i>
                <span slot="title">我的评价</span>
              </el-menu-item>
              <el-menu-item
                index="/Materialtoupload"
                v-if="this.$store.state.user.dentity !== '注册用户'"
              >
                <i class="iconfont gos-shangchuan1 tktb"></i>
                <span slot="title">我的上传</span>
              </el-menu-item>
              <el-menu-item
                index="/TaskList"
                v-if="this.$store.state.usert.dentity.includes('医生')"
              >
                <i class="iconfont gos-shangchuan1 tktb"></i>
                <span slot="title">任务列表</span>
              </el-menu-item>
            </el-menu>
          </el-col>
        </el-row>
      </div>
      <div class="right">
        <router-view />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      activeRoute: "",
    };
  },
  methods: {
    uploadmaterial() {
      if (this.$store.state.isLogin) {
        this.$router.push("/Uploadpagem");
      } else {
        this.$message({
          showClose: true,
          message: "请先进行登录",
          type: "warning",
        });
      }
    },
    handleOpen(key, keyPath) {},
    handleClose(key, keyPath) {},
  },
  computed: {
    activeMenu() {
      const route = this.$route;
      const { meta, path } = route;
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    },
  },
};
</script>
<style scoped lang="scss">
.Personalnav {
  margin-top: 10px;
  width: 100%;
  .concet-n {
    width: 1042px;
    margin: auto;
    background: #fff;
    display: flex;
    .left {
      margin-right: 23px;
      margin-left: 19px;
      .tac {
        padding-top: 24px;
        .el-col {
          width: 211px;
          border: 1px solid #f0f0f0;
          .el-menu-vertical-demo {
            .el-menu-item {
              font-size: 14px;
              border-left: 4px solid #fff;
            }
            .is-active {
              color: #4ccaff;
              border-left: 4px solid #4ccaff;
              background: #f9f9f9;
            }
          }
        }
      }
    }
    .right {
      padding-top: 24px;
      width: 772px;
      background: #ffffff;
      // border: 1px solid #F0F0F0;
      border-radius: 6px;
    }
  }
}
.tktb {
  margin-right: 10px;
}
.Materiaupload {
  position: fixed;
  top: 15.6rem;
  right: 11.2rem;
  span {
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #4ccaff;
  }
}
.altk {
  width: 48px;
  height: 48px;
  background: #4ccaff;
  border-radius: 6px;
  text-align: center;
  line-height: 48px;
  margin-bottom: 8px;
  .iconfont {
    font-size: 28px;
    color: #fff;
  }
}
// 适配手机端
@media (max-width: 768px) {
  .Personalnav {
    width: 100%;
    .concet-n {
      width: 100vw;
      display: block;
      .left {
        margin-left: 10px;
        .tac {
          padding-top: 24px;
          .el-col {
            width: 95vw;
          }
        }
      }
      .right {
        padding-top: 10px;
        width: 100vw;
      }
    }
  }
}
</style>
